import type { ChatVectorIndexOption } from "src/db";

export type DatasourceKind = "asset" | "document";

export const ASSET_DATASOURCE_IDS = ["pdc_portal", "gsd_core_products"] as const;

const normalize = (value: string | null | undefined): string =>
    (value ?? "").toLowerCase().replace(/[_\s]/g, "");

const isAsset = (option: ChatVectorIndexOption): boolean =>
    (ASSET_DATASOURCE_IDS as readonly string[]).includes(option.datasource_id);

export const matchesUserRole = ({
    option,
    userRoles,
}: {
    option: ChatVectorIndexOption;
    userRoles: string[];
}): boolean =>
    userRoles.some((role) => {
        const normalizedRole = normalize(role);
        const datasourceLabel = normalize(option.datasource_label);
        const indexLabel = normalize(option.label);
        return (
            normalizedRole.includes(datasourceLabel) ||
            datasourceLabel.includes(normalizedRole) ||
            normalizedRole.includes(indexLabel) ||
            indexLabel.includes(normalizedRole) ||
            normalizedRole === normalize(option.datasource_id)
        );
    });

export const datasourceKindOfTab = (tab: string | undefined): DatasourceKind => {
    const datasourceId = (tab ?? "").split("/")[0];
    return (ASSET_DATASOURCE_IDS as readonly string[]).includes(datasourceId)
        ? "asset"
        : "document";
};

export const visibleDatasources = ({
    all,
    userRoles,
    kind,
    requireIndex = false,
    availableAlwaysOnIds = new Set(),
}: {
    all: ChatVectorIndexOption[];
    userRoles: string[];
    kind: DatasourceKind;
    requireIndex?: boolean;
    availableAlwaysOnIds?: Set<string>;
}): ChatVectorIndexOption[] =>
    all.filter((option) => {
        const hasIndex = requireIndex === false || option.index_id !== "";
        const matchesKind = kind === "asset" ? isAsset(option) : isAsset(option) === false;
        const hasAccess =
            availableAlwaysOnIds.has(option.datasource_id) ||
            matchesUserRole({ option, userRoles });
        return hasIndex && matchesKind && hasAccess;
    });
